module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("627SC"))).then(() => parcelRequire('ijKQm'));